// extracted by mini-css-extract-plugin
export default {"mf_modal":"MfImportModal_mf_modal__qpB6U","dark":"MfImportModal_dark__XAPBD"};